import { render, staticRenderFns } from "./NlpWhoIsForIcon1.vue?vue&type=template&id=e8aa0a22"
import script from "./NlpWhoIsForIcon1.vue?vue&type=script&lang=js"
export * from "./NlpWhoIsForIcon1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports